import BadgesController from './badges.controller';

export default {
    template: require('./badges.tpl.html'),
    controller: BadgesController
};
